import { createSlice } from "@reduxjs/toolkit";

const getInitialState = () => ({
  state: sessionStorage.getItem("contentState") || "",
  previousState: sessionStorage.getItem("previousContentState") || "",
  subState: JSON.parse(sessionStorage.getItem("contentSubStates") || "{}"),
  // Transient deep-link request from Service Kai (e.g. open a training task or
  // tag-filter the recordings). Consumed and cleared by the target content view;
  // intentionally NOT persisted to sessionStorage so a refresh starts clean.
  deepLink: null,
});

const contentSlice = createSlice({
  name: "content",
  initialState: getInitialState(),
  reducers: {
    setTexting: (state) => {
      state.previousState = state.state;
      state.state = "Texting";
      sessionStorage.setItem("contentState", "Texting");
      sessionStorage.setItem("previousContentState", state.previousState);
    },
    setTraining: (state) => {
      state.previousState = state.state;
      state.state = "Training";
      sessionStorage.setItem("contentState", "Training");
      sessionStorage.setItem("previousContentState", state.previousState);
    },
    setSalesRecordings: (state) => {
      state.previousState = state.state;
      state.state = "Sales Recordings";
      sessionStorage.setItem("contentState", "Sales Recordings");
      sessionStorage.setItem("previousContentState", state.previousState);
    },
    setPayroll: (state) => {
      state.previousState = state.state;
      state.state = "Payroll";
      sessionStorage.setItem("contentState", "Payroll");
      sessionStorage.setItem("previousContentState", state.previousState);
    },
    setStats: (state) => {
      state.previousState = state.state;
      state.state = "Stats";
      sessionStorage.setItem("contentState", "Stats");
      sessionStorage.setItem("previousContentState", state.previousState);
    },
    setEvents: (state) => {
      state.previousState = state.state;
      state.state = "Events";
      sessionStorage.setItem("contentState", "Events");
      sessionStorage.setItem("previousContentState", state.previousState);
    },
    setTasks: (state) => {
      state.previousState = state.state;
      state.state = "Tasks";
      sessionStorage.setItem("contentState", "Tasks");
      sessionStorage.setItem("previousContentState", state.previousState);
    },
    setTaskManager: (state) => {
      state.previousState = state.state;
      state.state = "Task Manager";
      sessionStorage.setItem("contentState", "Task Manager");
      sessionStorage.setItem("previousContentState", state.previousState);
    },
    setContentState: (state, { payload }) => {
      state.previousState = state.state;
      state.state = payload;
      sessionStorage.setItem("contentState", payload);
      sessionStorage.setItem("previousContentState", state.previousState);
    },
    setSubState: (state, { payload }) => {
      const { parent, child } = payload;
      state.subState[parent] = child;
      sessionStorage.setItem(
        "contentSubStates",
        JSON.stringify(state.subState)
      );
    },
    clearSubState: (state, { payload }) => {
      if (payload) {
        delete state.subState[payload];
      } else {
        state.subState = {};
      }
      sessionStorage.setItem(
        "contentSubStates",
        JSON.stringify(state.subState)
      );
    },
    setDeepLink: (state, { payload }) => {
      state.deepLink = payload;
    },
    clearDeepLink: (state) => {
      state.deepLink = null;
    },
  },
});

export const {
  setPayroll,
  setSalesRecordings,
  setTexting,
  setTraining,
  setStats,
  setEvents,
  setTasks,
  setTaskManager,
  setContentState,
  setSubState,
  clearSubState,
  setDeepLink,
  clearDeepLink,
} = contentSlice.actions;
export default contentSlice.reducer;